import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressAnalytics = ({ student, detailed = false }) => {
  const mockProgressData = [
    {
      category: 'Quiz Complétés',
      current: 12,
      total: 15,
      percentage: 80,
      color: 'var(--color-primary)',
      icon: 'ClipboardCheck'
    },
    {
      category: 'Domaines Explorés',
      current: 8,
      total: 12,
      percentage: 67,
      color: '#10b981',
      icon: 'Compass'
    },
    {
      category: 'Badges Gagnés',
      current: 6,
      total: 12,
      percentage: 50,
      color: '#f59e0b',
      icon: 'Award'
    },
    {
      category: 'Recommandations Vues',
      current: 8,
      total: 8,
      percentage: 100,
      color: '#8b5cf6',
      icon: 'Lightbulb'
    }
  ];

  const mockMilestones = [
    {
      title: 'Premier Quiz Complété',
      date: '2026-01-15',
      achieved: true,
      icon: 'CheckCircle2'
    },
    {
      title: 'Niveau 3 Atteint',
      date: '2026-02-01',
      achieved: true,
      icon: 'TrendingUp'
    },
    {
      title: 'Toutes Recommandations Consultées',
      date: '2026-02-10',
      achieved: true,
      icon: 'Eye'
    },
    {
      title: 'Niveau 4 - Expert',
      date: 'En cours',
      achieved: false,
      icon: 'Target'
    }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="TrendingUp" size={24} className="text-primary" />
        <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">
          Analyse de Progression
        </h2>
      </div>

      {/* Progress Categories */}
      <div className="space-y-4 mb-6">
        {mockProgressData?.map((item, index) => (
          <div key={index}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <Icon name={item?.icon} size={16} className="text-muted-foreground" />
                <span className="text-sm md:text-base font-medium text-foreground">
                  {item?.category}
                </span>
              </div>
              <span className="text-sm md:text-base font-semibold" style={{ color: item?.color }}>
                {item?.current}/{item?.total}
              </span>
            </div>
            <div className="w-full bg-muted rounded-full h-3">
              <div
                className="h-3 rounded-full transition-all duration-500"
                style={{ width: `${item?.percentage}%`, backgroundColor: item?.color }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Milestones Section */}
      {detailed && (
        <div className="pt-6 border-t border-border">
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Flag" size={20} className="text-primary" />
            Jalons Importants
          </h3>
          <div className="space-y-3">
            {mockMilestones?.map((milestone, index) => (
              <div
                key={index}
                className={`flex items-start gap-3 p-3 rounded-lg ${
                  milestone?.achieved ? 'bg-success/10' : 'bg-muted'
                }`}
              >
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
                  milestone?.achieved
                    ? 'bg-success text-success-foreground'
                    : 'bg-muted-foreground/20 text-muted-foreground'
                }`}>
                  <Icon name={milestone?.icon} size={16} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm md:text-base font-medium text-foreground mb-1">
                    {milestone?.title}
                  </h4>
                  <p className="text-xs md:text-sm text-muted-foreground">{milestone?.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Quick Stats */}
      <div className="grid grid-cols-2 gap-4 mt-6 pt-6 border-t border-border">
        <div className="text-center">
          <p className="text-2xl md:text-3xl font-bold text-primary mb-1">
            {student?.progressPercentage}%
          </p>
          <p className="text-xs md:text-sm text-muted-foreground">Progression Globale</p>
        </div>
        <div className="text-center">
          <p className="text-2xl md:text-3xl font-bold text-success mb-1">2 450</p>
          <p className="text-xs md:text-sm text-muted-foreground">Points d'Exploration</p>
        </div>
      </div>
    </div>
  );
};

export default ProgressAnalytics;